import { render, staticRenderFns } from "./drawer-feedback.vue?vue&type=template&id=9a0965cc&scoped=true&"
import script from "./drawer-feedback.vue?vue&type=script&lang=js&"
export * from "./drawer-feedback.vue?vue&type=script&lang=js&"
import style0 from "./drawer-feedback.vue?vue&type=style&index=0&id=9a0965cc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0965cc",
  null
  
)

export default component.exports